import styled from 'styled-components';

export const TwoColumnImageText = styled.div`
  padding: 0;
  margin-top: 50px;
`;

export const LeftImage = styled.div`
  height: 100%;
  overflow: hidden;
  width: 100%;

  .lazy-load-image-background {
    display: block;
    width: 100%;
    height: 100%;
  }

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
  .contentblock_title {
    display: none;
    @media (max-width: 767.98px) {
      display: block;
      text-align: center;
      font-size: ${({ dir }) => (dir === 'rtl' ? '18px' : '16px')};
      margin-bottom: 1.5rem;
    }
  }

  &.contentblcok_bulletImg {
    @media (max-width: 991.98px) {
      padding: 0 30px;
    }
  }
`;

export const ContentPart = styled.div`
  height: 100%;
  padding: 50px 0;
  width: 100%;

  @media (max-width: 991.98px) {
    background-color: transparent;
    padding: 30px 0 0;
  }

  &.grey {
    background-color: #ebebeb;

    @media (max-width: 991.98px) {
      background-color: transparent;
      padding: 30px 0 0;
    }
  }
`;

export const InnerContentText = styled.div`
  display: flex;
  flex-flow: column;
  justify-content: center;
  width: 80%;
  margin: 0 auto;
  height: 100%;

  h3 {
    margin-bottom: 1.5rem;

    @media (max-width: 1199.98px) {
      font-size: 18px;
    }

    @media (max-width: 991.98px) {
      text-align: center;
    }

    @media (max-width: 767.98px) {
      font-size: 16px;
    }
  }

  p {
    color: #898989;
    margin-bottom: 1.5rem;
  }
  .title_innercontent {
    display: none;
    @media (min-width: 768px) {
      display: block;
    }
  }
`;

export const InnerContentUl = styled.ul`
  margin: 0;
  padding: 0;
  list-style-type: none;
`;

export const InnerContentLi = styled.li`
  color: #898989;
  margin-bottom: 1.5rem;
  position: relative;
  display: flex;
  align-items: center;

  &:before {
    display: block;
    content: '';
    width: 0;
    height: 0;
    background: 0 0 !important;
    border: solid #000;
    border-width: 0 2px 2px 0;
    padding: 4px;
  }

  &[dir='ltr'] {
    &:before {
      margin-right: 30px;
      transform: rotate(-45deg);
    }
  }

  &[dir='rtl'] {
    &:before {
      margin-left: 30px;
      transform: rotate(135deg);
    }
  }
`;
